const en_gb = {
  // Generic useful words
  add: "Add",
  answers: "Answers",
  approve: "Approve",
  cancel: "Cancel",
  clear: "Clear",
  close: "Close",
  create: "Create",
  delete: "Delete",
  description: "Description",
  download: "Download",
  edit: "Edit",
  ellipsis: "...",
  error: "Error",
  error_downloading: "Unable to download the requested file.",
  filter: "Filter",
  finish: "Finish",
  go: "Go ...",
  loading: "Loading ...",
  open: "Open ...",
  public: "Public",
  published: "Published",
  question: "Question",
  remove: "Remove",
  restricted: "Restricted",
  save: "Save",
  save_and_finish: "Save and finish",
  saved: "Saved",
  shared: "Shared",
  title: "Title",
  unpublished: "Unpublished",
  unshared: "Not shared",
  upload: "Upload",
  tax_vat: "VAT",
  list_time_ago: "{timeAgo} ago",
  time_ago: "{timeAgo} ago",
  updated_time_ago: "Updated {timeAgo} ago",
  total: "Total",
  success: "Success",

  click_to_continue: "Click here to continue ...",

  // Banner titles
  banner_title_content_curation_categories: "Content Curation - Categories",
  banner_title_content_curation_collections: "Content Curation - Collections",
  banner_title_curate_collection: "Curate Collection",
  banner_title_curate_content: "Curate Content",
  banner_title_curate_content_category: "Curate Content Category",
  banner_title_curate_new_content_category: "New Content Category",
  banner_title_new_collection: "New Collection",
  banner_title_new_content: "New Content",
  banner_title_content_curation_content: "Content Curation - Content",
  banner_title_content_curation_tags: "Content Curation - Tags",
  banner_title_content_curation_tag_category: "Curate Tag Category",

  banner_title_forum_categories: "Forum",
  banner_title_forum_category: "Forum Category",
  banner_title_forum_category_add: "Add Forum Category",
  banner_title_forum_category_edit: "Edit Forum Category",
  banner_title_forum_post: "Forum Post",
  banner_title_forum_post_add: "Add Forum Post",
  banner_subtitle_forum_categories: "Categories",
  // banner_subtitle_forum_category: "Category: {title}",

  // banner_title_preview: "Preview",
  banner_title_payment_callback: "Payment Confirmation",

  banner_title_user_register: "{siteTitle} Registration",
  banner_title_user_register_groups: "Group Membership",
  banner_title_user_register_verify: "Account Verification",

  banner_title_force_password_change: "Change Your Password",

  banner_title_admin_page: "Page",
  banner_title_admin_page_add: "New page",
  banner_title_admin_page_edit: "Edit page",

  banner_title_admin_images: "Images",

  banner_title_login_or_register: "Log In or Register",

  // Breadcrumbs
  breadcrumb_admin: "Admin",
  breadcrumb_admin_page: "Page",
  breadcrumb_admin_images: "Images",
  breadcrumb_categories: "Categories",
  breadcrumb_collection: "Collection",
  breadcrumb_collections: "Collections",
  breadcrumb_content: "Content",
  breadcrumb_content_category: "Content Category",
  breadcrumb_content_item: "Content Item",
  breadcrumb_curation: "Curation",
  breadcrumb_dashboard: "Dashboard",
  breadcrumb_forum: "Forum",
  breadcrumb_forum_category: "Category",
  breadcrumb_forum_category_add: "Add Forum Category",
  breadcrumb_forum_category_edit: "Edit Forum Category",
  breadcrumb_forum_post: "Post",
  breadcrumb_forum_post_add: "New Post",
  breadcrumb_new_collection: "New Collection",
  breadcrumb_new_content: "New Content",
  breadcrumb_new_content_category: "New Content Category",
  breadcrumb_tags: "Tags",
  breadcrumb_tags_category: "Tag Category",

  // Form labels
  label_content_type: "Content Type",
  label_external_url: "External URL",
  label_forum: "Forum",
  label_published: "Published",
  label_template: "Template",

  // Curation
  collection_compulsory_content: "Compulsory Path",
  collection_optional_content: "Optional Elements",
  curation_collection_add_content: "Add content",
  curation_collection_add_content_compulsory: "Add compulsory content",
  curation_collection_add_content_optional: "Add optional content",
  curation_collection_add_content_existing: "Add existing content",
  curation_collection_add_content_new: "Create new content",
  curation_collection_add_content_select_type: "What type of content would you like to add?",
  curation_collection_add_content_create_new_instructions:
    "Select a content type to add, then provide the requested details. The content may be configured further by\
    editing it in the content manager after creation",
  curation_collection_add_content_description_title: "Content title.",
  curation_collection_add_content_description_description:
    "Content description. For instructional (free text) content, this is the text content which is displayed to the\
    user.",
  curation_collection_add_content_description_pdl_description:
    "Text added to the user's PDL when the content is completed.",
  curation_collection_add_content_description_forum_category: "The forum category which this content links to.",
  curation_collection_add_content_description_training_date: "Date for live training.",
  curation_collection_add_content_label_title: "Title *",
  curation_collection_add_content_label_description: "Description *",
  curation_collection_add_content_label_pdl_description: "PDL Description *",
  curation_collection_add_content_label_forum_category: "Forum Category *",
  curation_collection_add_content_label_training_date: "Training Date *",
  curation_content_type_select: "Select a content type",
  curation_content_type_active: "Active content",
  curation_content_type_static: "Static content",
  curation_content_type_text: "Instruction (free text)",
  curation_content_type_forum: "Forum category",
  curation_content_type_live_training: "Live training",
  curation_collection_add_content_go: "Add content",
  curation_collection_add_content_filter_text_label: "Filter content by title or description",
  curation_collection_add_content_filter_type_label: "Filter content by type",
  curation_collection_add_content_filter_active: "Active",
  curation_collection_add_content_filter_static: "Static",
  curation_collection_add_content_filter_text: "Instruction (free text)",
  curation_collection_add_content_filter_forum: "Forum category",
  curation_collection_add_content_filter_live_training: "Live training",
  curation_collection_add_content_add_all: "Add all",
  curation_collection_add_content_no_content_found: "No content found.",
  curation_collection_set_background_image: "Set collection background image",
  curation_collection_content_help:
    "This collection contains the content shown below. Content items may be dragged to re-order them.",
  curation_collection_loading_content: "Loading content ...",

  curation_collection_tab_details: "Details",
  curation_collection_tab_preview: "Preview",

  collection_template_stream: "Stream",
  collection_template_pathway: "Pathway",
  collection_template_external: "External Link",

  curation_collection_content_remove_failed: "Unable to remove content from collection",
  curation_collection_delete_failed: "Unable to delete collection",
  curation_collection_description_help: "Collection description",
  curation_collection_external_url_help:
    "External Link template only: users will be taken to this URL when they click on this collection's tile.",
  curation_collection_intro:
    "This page allows you to configure the collection, and add content to it. The preview shows the approximate\
     layout of the collection as it will appear to learners.",
  curation_collection_tile_imagery_label: "Tile Imagery",
  curation_collection_tile_imagery_help: "The collection's tile will display with the imagery shown above.",
  curation_collection_published: "Published",
  curation_collection_published_help: "If published, the collection will be available for viewing by learners.",
  curation_collection_modal_confirm_delete_message_1: "You are about to delete the following collection:",
  curation_collection_modal_confirm_delete_message_2:
    "This will completely remove it from the system. Access to the collection will be lost by all users. The\
    collection's content will not be deleted. If the collection has a forum category associated with it, it will\
    be unpublished. Are you sure you wish to continue?",
  curation_collection_modal_confirm_delete_title: "Delete Collection?",
  curation_collection_modal_confirm_publish_message:
    "You are about to publish this collection. Doing so will make it available to other users. Are you sure you wish\
    to continue?",
  curation_collection_modal_confirm_publish_message_1: "You are about to publish the following collection:",
  curation_collection_modal_confirm_publish_message_2:
    "Doing so will make it available to other users. Are you sure you wish to continue?",
  curation_collection_modal_confirm_publish_title: "Publish Collection?",
  curation_collection_modal_confirm_remove_content_title: "Remove Content from Collection?",
  curation_collection_modal_confirm_remove_content_message_1:
    "You are about to remove the following content from this collection:",
  curation_collection_modal_confirm_remove_content_message_2:
    "Doing so will make it unavailable from within this collection. Are you sure you wish to continue?",
  curation_collection_modal_confirm_unpublish_message:
    "You are about to unpublish this collection. Doing so will make it unavailable to other users. Are you sure you\
    wish to continue?",
  curation_collection_modal_confirm_unpublish_message_1: "You are about to unpublish the following collection:",
  curation_collection_modal_confirm_unpublish_message_2:
    "Doing so will make it unavailable to other users. Are you sure you wish to continue?",
  curation_collection_modal_confirm_unpublish_title: "Unpublish Collection?",
  curation_collection_source: "Source",
  curation_collection_template_help: "This collection's type. Note: may not be changed after template creation.",
  curation_collection_title_help: "Collection title",
  curation_collection_preview_external_help_1: "This collection is a link to an external page and cannot be previewed.",
  curation_collection_preview_external_help_2: "Click the following link to view the page:",
  curation_collection_remove_content: "Remove content item from the collection",
  curation_collection_set_content_prerequisites: "Set pre-requisites for viewing this content",
  curation_collection_set_content_prerequisites_modal_title: "Set Content Pre-requisites",
  curation_collection_set_content_prerequisites_modal_message:
    "Please select which other content must be completed before this content becomes available.",
  curation_collection_set_content_prerequisites_none: "None: this content is always available for completion.",
  curation_collection_set_content_prerequisites_previous:
    "All previous: all previous content in the pathway must be completed before this content will become available.",
  curation_content_attachments_current_file: "Current file",
  curation_content_attachments_current_file_none: "no file",
  curation_content_delete_failed: "Unable to delete content item",
  curation_content_description_help: "Content description",
  curation_content_intro:
    "This page allows you to configure the content item and - where relevant - add questions to it.",
  curation_content_category_no_category: "No category",
  curation_content_categories_add_category_description_description: "Category description.",
  curation_content_categories_add_category_label_description: "Description *",
  curation_content_categories_add_category_description_global:
    "Whether this category is global (available to all companies) or specific to your company only.",
  curation_content_categories_add_category_label_global: "Global",
  curation_content_categories_add_category_description_title: "Category title.",
  curation_content_categories_add_category_label_title: "Title *",
  curation_content_categories_create_error: "There was a problem creating the new category.",
  curation_content_categories_delete_failed: "Unable to delete category",
  curation_content_categories_intro_normal:
    "Content categories are applied to static content. All content in the same category is grouped together when it is\
    displayed to the user in the collection resources tab.",
  curation_content_category_modal_confirm_delete_message:
    "You are about to permanently delete a content category. Are you sure you wish to continue?",
  curation_content_category_modal_confirm_delete_title: "Delete Content Category?",
  curation_content_categories_edit_category_intro:
    "You are editing a content category which may be assigned to static content items. Note, any changes made here\
    will be reflected across the site on all content which belongs to this category.",
  curation_content_categories_new_category_intro:
    "You are creating a new content category which may be assigned to static content items.",
  curation_content_categories_intro_superadmin:
    "As a superadministrator you may manage global categories which are available to all companies.",
  curation_content_categories_new_category: "New Category",
  curation_content_configuration_click_to_edit: "Configuration options (click to edit)",
  curation_content_label_attachments: "Attached document",
  curation_content_label_attachments_placeholder: "Click to choose a file or drag to drop it here ...",
  curation_content_label_attachments_placeholder_dragging: "Drop file here ...",
  curation_content_label_content_category: "Content Category",
  curation_content_label_external_resource: "External Resource",
  curation_content_label_external_resource_accreditation: "External Resource Accreditation",
  curation_content_label_feedback: "Completion Feedback",
  curation_content_label_forum_category: "Forum Category",
  curation_content_label_instructions: "Instructions",
  curation_content_label_live_training_date: "Training Date",
  curation_content_label_newsletter_text: "Newsletter Text",
  curation_content_label_pdl_description: "PDL Details",
  curation_content_label_cpd_score: "CPD Score",
  curation_content_label_tile_imagery: "Content Imagery",
  curation_content_label_video_source: "Video Source",
  curation_content_label_video_type: "Video Type",
  curation_content_help_attachments:
    "A document which learners may download. Permitted formats: 'doc', 'docx', 'odt' and 'pdf'.\
    Maximum file size: 10MB.",
  curation_content_help_content_category:
    "Static content may be assigned to a category which determines which other content it is grouped with.",
  curation_content_help_external_resource: "A link to an online resource which is external to this portal.",
  curation_content_help_external_resource_accreditation: "Accreditation for any external resource.",
  curation_content_help_feedback:
    "Completion feedback is shown when a user completes and logs the content. It is normally used to explain the\
    correct answers to questions.",
  curation_content_help_forum_category: "The forum category which this content links to.",
  curation_content_help_instructions: "Content instructions. Shown on the content page itself.",
  curation_content_help_live_training_date: "Date for live training.",
  curation_content_help_newsletter_text:
    "The default newsletter text used when this content is included in a newsletter. If this is left empty then the\
     content's description will be used instead. This text may be overridden in newsletters as needed.",
  curation_content_help_pdl_description:
    "The PDL details are added to a user's PDL when they log completion of the content item. This should be a summary\
     of what the user achieved in completing the content.",
  curation_content_help_cpd_score:
    "The total CPD score available for this content. If the content has questions, the score is split between them\
     (final score rounded up).",
  curation_content_help_tile_imagery: "The content item's tile will display with the imagery shown above.",
  curation_content_help_video_source:
    "Video sources take the following formats: YouTube: eisKxhjBnZ0; Vimeo: 83659693;\
     Google: 1UL52DwHQOnCo37SUsnmlLhpf4pqC4daG; TED: mike_velings_the_case_for_fish_farming;\
     HBR: 4748457569001 or 4748457569001/the-strategy-trap-successful-companies-fall-into.",
  curation_content_help_video_type: "Identifies the source of video to be shown in the content",
  curation_content_modal_confirm_delete_message_1: "You are about to delete the following content item:",
  curation_content_modal_confirm_delete_message_2:
    "This will completely remove it from the system. Are you sure you wish to continue?",
  curation_content_modal_confirm_delete_title: "Delete Content Item?",
  curation_content_modal_confirm_remove_file_title: "Remove File?",
  curation_content_modal_confirm_remove_file_message:
    "Are you sure you wish to remove this file? It will be permanently deleted.",
  curation_content_restricted_help:
    "By default, content shows up in searches carried out by any learner in your company, and may then be accessed by\
     them without restriction. Restricting the content ensures that it may only be found and accessed by learners who\
     are members of groups with explicit permission to view it.",
  curation_content_tags_edit_tag_category: "Edit the tags in this category",
  curation_content_tags_intro: "Please select the tags which apply to this content.",
  curation_content_tags_no_category_tags: "No tags have been created for this category",
  curation_content_tags_no_categories_found: "No tag categories found",
  curation_content_tags_title_filter_label: "Filter by category title or child tag",
  curation_content_source: "Source",
  curation_content_tab_details: "Details",
  curation_content_tab_questions: "Questions",
  curation_content_tab_tags: "Tags",
  curation_content_title_help: "Content title",
  curation_content_type_help: "This content's type. Note: may not be changed after content creation.",
  curation_content_video_type_none: "No video",
  curation_content_video_type_youtube: "YouTube",
  curation_content_video_type_ted: "TED",
  curation_content_video_type_vimeo: "Vimeo",
  curation_content_video_type_hbr: "Harvard Business Review",
  curation_content_question_answer_answer_label: "Answer",
  curation_content_answer_answer_help: "Answer text displayed to the learner",
  curation_content_answer_correct_label: "Correct",
  curation_content_answer_correct_help: "Whether this is a correct answer",
  curation_content_question_answer_delete: "Delete answer",
  curation_content_question_answer_modal_confirm_delete_title: "Delete Answer?",
  curation_content_question_answer_modal_confirm_delete_message: "Are you sure you wish to delete this answer?",
  curation_content_question_answer_reorder: "Reorder answers",
  curation_content_question_delete: "Delete question",
  curation_content_question_modal_confirm_delete_message: "Are you sure you wish to delete this question?",
  curation_content_question_modal_confirm_delete_title: "Delete Question?",
  curation_content_question_open_question: "Open Question",
  curation_content_question_close_question: "Close Question",
  curation_content_question_feedback_help: "Feedback about the question provided when the learner's score is revealed.",
  curation_content_question_question_help: "Question text displayed to the learner.",
  curation_content_question_feedback_label: "Feedback",
  curation_content_question_question_label: "Question",
  curation_content_questions_new_answer_label: "New answer",
  curation_content_questions_new_answer_description: "Enter the new answer's text and press the 'Add' button.",
  curation_content_questions_new_answer_placeholder: "Enter answer text ...",
  curation_content_questions_new_answer_add_title: "Add answer",
  curation_content_questions_new_question_label: "New question",
  curation_content_questions_new_question_placeholder: "Enter question text ...",
  curation_content_questions_new_question_description: "Enter the new question's text and press the 'Add' button.",
  curation_content_questions_new_question_add_title: "Add question",
  curation_content_question_reorder: "Reorder questions",
  curation_create_collection: "Create a new collection",
  curation_create_collection_error: "Unable to create collection",
  curation_delete_collection: "Delete collection",
  curation_edit_collection: "Edit collection",
  curation_create_content: "Create a new content item",
  curation_create_content_error: "Unable to create content item",
  curation_delete_content: "Delete content item",
  curation_delete_content_category: "Delete content category",
  curation_edit_content: "Edit content item",
  curation_filter_all: "All",
  curation_filter_by_title_or_description: "Filter by title or description",
  curation_filter_created_by_me: "Created by me",
  curation_collection_forum_help: "Publish the Firm Academy forum which is assocated with this collection.",
  curation_loading_collections: "Loading collections ...",
  curation_loading_content: "Loading content ...",
  curation_new_collection_intro:
    "You are creating a new content collection. First, please provide a title and description for the collection, and\
     then select which type of collection you wish to build.",
  curation_new_content_intro:
    "You are creating a new content item. Please enter its basic information below. You will be able to add more\
     details once the content is created.",
  curation_published_failed: "Unable to save",
  curation_published_saved: "Saved ok",
  curation_tab_collections: "Collections",
  curation_tab_content: "Content",
  curation_tab_categories: "Categories",
  curation_tab_tags: "Tags",
  curation_tag_categories_intro:
    "Tag categories are used to group related content tags together. Tags may be used to help filter searches and\
    otherwise organise content.",
  curation_tag_categories_title_filter_label: "Filter by category title or child tag",
  curation_tag_categories_delete_failed: "Unable to delete tag category",
  curation_tag_categories_new_category: "New Tag Category",
  curation_tag_categories_delete: "Delete tag category",
  curation_tag_categories_modal_confirm_delete_title: "Delete Tag Category?",
  curation_tag_categories_modal_confirm_delete_message:
    "Are you sure you wish to delete this tag category? All child tags which are not in another category will also be\
    removed",
  curation_tag_categories_child_tag_filter_match: "(child tag matches filter)",
  curation_tag_categories_new_tag_title_exists: "A tag category with this title already exists.",
  curation_tag_categories_modal_create_category: "Create New Tag Category",
  curation_tag_categories_new_tag_create_another: "Create another",
  curation_tag_categories_new_tag_create_another_title:
    "Keep this modal open after saving so that another tag category may be created.",
  curation_tag_categories_no_categories_found: "No categories found",
  curation_tag_category_title_description: "Set the tag category title.",
  curation_tag_category_tag_delete: "Delete tag",
  curation_tag_category_tag_title_filter_label: "Filter by tag title",
  curation_tag_category_tag_delete_failed: "Unable to delete tag",
  curation_tag_category_tag_new_tag: "New Tag",
  curation_tag_category_tag_modal_confirm_delete_title: "Delete Tag?",
  curation_tag_category_tag_modal_confirm_delete_message:
    "Are you sure you wish to remove this tag from this category?",
  curation_tag_category_tag_modal_create_title: "Add Tag",
  curation_tag_category_tag_new_tag_title_exists: "A tag with this title already exists in this category.",
  curation_tag_category_tag_new_tag_create_another: "Create another",
  curation_tag_category_tag_no_tags_found: "No tags found",
  curation_tag_category_tags_title: "Tags",

  // Forum pages
  forum_error_get_category: "Unable to fetch category data.",

  forum_categories_list_add_category: "Add Category",
  forum_categories_confirm_delete_category_body:
    "Are you sure you wish to delete forum category '{categoryTitle}'? All data associated with it including posts \
    and comments will also be removed. Users' development logs are retained.",
  forum_categories_confirm_delete_category_title: "Delete Forum Category?",
  forum_categories_error_get_categories: "Unable to fetch category list.",
  forum_categories_error_deleting_category: "Unable to delete forum category.",
  forum_categories_error_updating_category: "Unable to update forum category.",
  forum_categories_heading_collection_categories: "Collections",
  forum_categories_heading_general_categories: "General Discussion",
  forum_categories_list_external_company: "External",
  forum_categories_list_heading_category: "Category",
  forum_categories_list_heading_collection: "Collection",
  forum_categories_list_heading_company: "Company",
  forum_categories_list_heading_description: "Description",
  forum_categories_list_heading_posts: "Posts",
  forum_categories_list_heading_updated: "Updated",
  forum_categories_list_no_categories_found: "No categories found.",
  forum_categories_list_public_company: "Public",
  forum_categories_list_title_unread: "Contains unread posts",
  forum_categories_more_category: "More Categories",
  forum_categories_filter_category_list: "Filter category list ...",
  forum_categories_category_list_empty: "No categories found.",
  forum_categories_heading_non_admin: "Forum Categories",
  forum_categories_list_no_public_access: "You do not have access to public content.",

  forum_category_description_help: "The forum category's description.",
  forum_category_unavailable: "This forum category is currently unavailable.",
  forum_category_unable_to_get_category: "Unable to display this forum category.",
  forum_category_edit_error_get_category: "Unable to fetch category data.",
  forum_category_edit_icon_label: "Category Icon",
  forum_category_edit_icon_help: "The icon used to represent the category in the UI.",
  forum_category_edit_icon_upload: "Forum Category Icon",
  forum_category_published_help: "Whether or not the category is published (available to users in your company).",
  forum_category_shared_help: "Whether or not the category is shared (available to users in other companies).",
  forum_category_title_help: "The forum category's title.",
  forum_category_title_help_subject:
    "This is the discussion forum for the {collectionTitle} collection. Its title automatically matches that of the \
      collection and cannot be edited here.",
  forum_category_add_icon: "Note: you will be able to add an icon to this category after it is created.",
  forum_category_add_new: "New Forum Category",
  forum_category_create_error_creating: "Unable to create forum category.",
  forum_category_error_get_category: "Unable to get the forum category.",
  forum_category_no_posts_found: "No posts found.",
  forum_category_post: "Post",
  forum_category_author: "Author",
  forum_category_post_last_update: "Updated",
  forum_category_comments_count: "Comments",
  forum_category_confirm_delete_post_title: "Delete Post",
  forum_category_confirm_delete_post_body:
    'Are you sure you want to delete the post "{postTitle}"? It and all its comments will be completely \
    removed.',
  forum_category_error_deleting_post: "Unable to delete post.",
  forum_category_confirm_approve_post_title: "Approve Post?",
  forum_category_confirm_approve_post_body:
    'Are you sure you want to approve the post "{postTitle}"? It will become visible to all users who have access to \
    this forum category.',
  forum_category_add_post: "New Post",
  forum_category_admin: "Admin:",
  forum_category_filter_post_list: "Filter post list ...",
  forum_category_post_list_empty: "No posts found.",
  forum_category_for_collection: "Discussion forum for content collection:",
  forum_category_adding_new_post_to_category: 'You are adding a new post to "{categoryTitle}".',
  forum_category_follow: "Click to follow this category",
  forum_category_following: "You are following this category",
  forum_category_follow_error: "Unable to follow this category.",
  forum_category_follow_ok: "You are now following this category.",
  forum_category_unfollow_error: "Unable to unfollow this category.",
  forum_category_unfollow_ok: "You are no longer following this category.",

  forum_post_not_sticky: "Not sticky",
  forum_post_sticky: "Sticky",
  forum_post_unread: "Contains unread content",
  forum_post_unavailable: "This forum post is currently unavailable.",
  forum_post_unable_to_get_post: "Unable to display this forum post.",
  forum_post_error_updating_post: "Unable to update post.",
  forum_post_success_updating_post: "Forum post updated successfully.",
  forum_post_pending_approval: "Pending approval",
  forum_post_anonymous_pending_approval_notice:
    "You posted this anonymously. It is currently pending approval from an admin.",
  forum_post_anonymous_approved_notice:
    "You posted this anonymously. It has been approved and is visible to other users.",
  forum_post_anonymous_flag: "Anonymous",
  forum_post_comments: "Comments allowed",
  forum_post_comments_off: "Comments disabled",
  forum_post_title_help: "The headline for your post.",
  forum_post_post_label: "Post",
  forum_post_post_help: "What do you want to say?",
  forum_post_post_characters: "{postLength} / 4000 (including HTML tags)",
  forum_post_post_invalid: "Post text is required and must be 4000 characters or fewer in length.",
  forum_post_anonymous_help:
    "You will not be shown as the author of this post. Note that what you write will need to be approved by a site \
    admin before it becomes visible.",
  forum_post_anonymous_label: "Post Anonymously",
  forum_post_log_help: "A note will be added into your {pdlText} indicating that you contributed to this forum.",
  forum_post_log_label: "Log in {pdlText}",
  forum_post_sticky_help:
    "A sticky post always appears at the top of the category listing (only admin users like you may set this).",
  forum_post_sticky_label: "Sticky",
  forum_post_comments_help: "Allow users to submit comments about the post (only admin users like you may set this).",
  forum_post_comments_label: "Allow Comments",
  forum_post_create_error_creating: "Unable to create new post.",
  forum_post_error_get_post: "Unable to get the post.",
  forum_post_edit_instructions:
    "You may edit your post during the first hour after creating it. After this the post will be locked.",
  forum_post_edit_instructions_anonymous:
    "Since you contributed anonymously the post may be locked sooner once an admin has approved what you wrote.",
  forum_post_discussion_no_comments: "Nobody has said anything about this post. Why not start the discussion?",
  forum_post_discussion_comments_after_approval: "It will be possible to add comments once the post is approved.",
  forum_post_add_comment: "Add comment",
  forum_post_comment: "Comment",
  forum_post_comment_label: "Comment",
  forum_post_comment_invalid: "Comment text is required and must be 4000 characters or fewer in length.",
  forum_post_comment_anonymous_help:
    "You will not be shown as the author of this comment. Note that what you write will need to be approved by a site \
    admin before it becomes visible.",
  forum_post_comment_anonymous_label: "Comment Anonymously",
  forum_post_comment_log_help:
    "A note will be added into your {pdlText} indicating that you contributed to this forum.",
  forum_post_comment_log_label: "Log in {pdlText}",
  forum_post_comment_success_creating: "You have commented on this post.",
  forum_post_comment_error_creating: "Unable to create comment.",
  forum_post_comment_user_unknown: "A User",
  forum_post_comment_reply: "Reply",
  forum_post_comment_removed_text: "This comment has been removed.",
  forum_post_comment_confirm_delete_comment_title: "Delete Comment?",
  forum_post_comment_confirm_delete_comment_body:
    "Are you sure you wish to delete the comment? It will no longer be shown in this post. \
    This action cannot be undone.",
  forum_post_comment_error_deleting_comment: "Unable to delete the comment.",
  forum_post_discussion_closed: "This post's discussion is closed.",
  forum_post_comment_editable_instructions:
    "You may edit your comment during the first hour after creating it. After this the comment will be locked.",
  forum_post_comment_editable_anonymous_instructions:
    "Since you contributed anonymously the comment may be locked sooner once an admin has approved what you wrote.",
  forum_post_confirm_approve_post_title: "Approve Comment?",
  forum_post_confirm_approve_post_body:
    "Are you sure you want to approve the comment? It will become visible to all users who have access to \
    this forum category.",
  forum_post_user_unknown: "A User",
  forum_post_error_reacting: "Unable to save your reaction.",
  forum_post_anonymous_unapproved: "Posted anonymously, pending approval.",
  forum_post_anonymous_approved: "Posted anonymously, approved.",
  forum_post_created: "Authored: {created}",
  forum_post_updated: "Updated: {updated}",
  forum_comment_success_approve_comment: "Comment approved.",
  forum_comment_error_approve_comment: "Unable to approve comment.",
  forum_category_private: "Private forum category",
  forum_category_public: "Public forum category",
  forum_category_public_flag: "Public",
  forum_category_public_description:
    "This is a public area of the forum. People from other companies may see what you write.",
  forum_post_more_category_posts: "More Posts",
  forum_post_view_author_profile: "View author's profile",
  forum_post_post: "post",
  forum_post_follow_title: "Follow Post",
  forum_post_follow_label:
    "You will will be notified when users comment on your post. The notifications you receive may be \
    configured in your account settings.",
  forum_post_follow: "Click to follow this post",
  forum_post_following: "You are following this post",
  forum_post_follow_error: "Unable to follow this post.",
  forum_post_follow_ok: "You are now following {postTitle}.",
  forum_post_unfollow_error: "Unable to unfollow this post.",
  forum_post_unfollow_ok: "You are no longer following {postTitle}.",
  forum_category_admin_warning_not_published:
    "This category is not published and cannot be accessed by non-admin users.",
  forum_category_no_posts: "There are no posts here yet. Why not start the discussion?",

  // Error messages
  error_forbidden: "Forbidden - you do not have permission to access the page you requested.",
  errror_not_found: "Page not found - we could not find the page you are looking for.",

  // Footer
  footer_copyright: "Copyright &copy;",
  footer_privacy_policy: "Privacy Policy",

  // Help modals
  help_help: "Help:",
  help_content_collection_template:
    "<p>A collection's template defines how its content is presented to users. There are three templates available:</p>\
    <ul><li><strong>Stream:</strong> A generic collection in which all of the content is always available.</li>\
    <li><strong>Pathway:</strong> A structured collection in which the content is ordered into a pathway.</li>\
    <li><strong>External Link:</strong> A link to external content.</li></ul>\
    <p>Note: a collection's template may not be changed once the collection has been created.</p>",
  help_subject_collection_template: "Collection Templates",
  help_content_collections:
    "Collections gather related content together. Users and collections are placed into groups. Users in the same\
    group as a collection have permission to view the collection and its content.",
  help_subject_collections: "Collections",
  help_content_content:
    "Each content item is a single learning engagement which may be completed by a learner. Content items are placed\
     into collections where learners may access them.",
  help_subject_content: "Content",
  help_content_content_type:
    "<p>There are a number of different types of content.</p><ul><li>Active content - typically a bite-sized piece of\
     content with an assessment.</li><li>Static content - an unassessed reference providing information only.</li><li>\
     Instruction (free text) - free text content, primarily intended for embedding into the flow of a collection.</li>\
     <li>Forum category - a content item which loads up a specified forum category.</li><li>Live training - details\
     about a live training event which you may attend.</li></ul><p>Note: a content item's type may not be changed\
     once the it has been created.</p>",
  help_subject_content_type: "Content Types",

  // Image Uplaoder
  image_uploader_background_help: "Can't see your image? Try changing the image cropper background color:",
  image_uploader_background_set_light: "Set background light",
  image_uploader_background_set_dark: "Set background dark",
  image_uploader_edit_image: "Edit Image",
  image_uploader_no_image: "No Image Selected",
  image_uploader_remove_image: "Remove Image",
  image_uploader_remove_image_title: "Remove Image?",
  image_uploader_remove_image_ok: "Remove Image",
  image_uploader_remove_image_confirm_text: "Are you sure you wish to remove this image?",
  image_uploader_upload_image: "Upload Image",
  image_uploader_image_size:
    "The image will be displayed at {width} by {height} pixels. Smaller images may be\
    uploaded but will be scaled, which may result in loss of quality.",
  // image_uploader_image_resize:
  //   "The image will be displayed with a width of {width} pixels. Its height will automatically be scaled if the \
  //   aspect ratio is changed from the default.",
  image_uploader_image_resize:
    "You can resize and crop the image using the slider and the square white 'handles' on the right and bottom of the \
    image.",
  image_uploader_image_name_from_file:
    "The uploaded file will have the same name as the original file, except non alpha-numeric characters will be \
    replaced with underscores. If a file is provided with a name matching that of a previously uploaded file, the \
    previous file will be replaced.",
  image_uploader_error_uploading: "Unable to upload the selected image.",

  // Inline form elements
  inline_form_error_required: "Value is required",
  inline_form_error_too_long: "Too many characters",
  inline_form_error_unable_to_save: "Unable to save",
  inline_form_error_url_required: "Value must be a valid URL",
  inline_form_error_valid_input_required: "Value is not valid",
  inline_form_length: "{length} / {maxlength} (including HTML tags)",

  // Navigation
  nav_about: "About",
  nav_admin: "Admin",
  nav_curation: "Curation",
  nav_forum: "Forum",
  nav_log_in: "Log In",
  nav_log_out: "Log Out",
  nav_my_account: "My Account",
  nav_newsletters: "Newsletters",
  nav_pdl: "PDL",

  // User forced change password page
  user_force_change_password_description: "You must change your password before continuing to use the site.",
  user_force_change_password_specification:
    '<p>Your new password may contain any character and must:</p> \
    <ul class="mb-0">\
    <li>Be a minimum of eight characters long</li>\
    <li>Contain at least one upper-case letter</li>\
    <li>Contain at least one lower-case letter</li>\
    <li>Contain at least one number</li>\
    </ul>',
  user_force_change_password_password: "New Password",
  user_force_change_password_confirm_password: "Confirm New Password",
  user_force_change_password_save: "Change Password",
  user_force_change_password_save_error: "There was a problem saving your new password.",
  user_force_change_password_save_success: "Password changed ok.",
  user_force_change_password_success_feedback: "You have updated your password. Please click here to continue.",

  // User registration pages
  user_register_company_name: "Firm name",
  user_register_company_name_description: "The name of the firm you work for.",
  user_register_email: "E-mail",
  user_register_email_description: "Your e-mail address.",
  user_register_simple_name: "Name",
  user_register_simple_name_description:
    "Your name. This will be automatically converted to first name and surname. For best results please enter both \
    with a space between, e.g. 'Joe Bloggs'.",
  user_register_firstname: "First Name",
  user_register_firstname_description: "Your first name.",
  user_register_instructions:
    "To start benefitting, simply add below the details of all the people in your firm who would like to make use \
    of {siteTitle}. If you are registering on behalf of others, please advise them to expect to receive an email \
    from {siteTitle} asking them to verify their account.",
  user_register_instructions_help:
    "If you are registering a large number of users you may find it easier to email a spreadsheet containing the \
    above details to <a href='{mailto}:{email}'>{email}</a>. \
    If you experience any problems registering or logging in please email <a href='{mailto}:{email}'>{email}</a>.",
  user_register_lastname: "Last Name",
  user_register_lastname_description: "Your last name.",
  user_register_register: "Register",
  user_register_register_another_user: "Register another user",
  user_register_register_error_not_allowed_domain:
    "{siteTitle} does not recognise your email address as that of a member firm. Could you please check and try \
    again. Email accounts such as gmail or yahoo cannot be automatically verified. If you continue to experience \
    problems, please accept our apologies and email your details to: <a href='{mailto}:{email}'>{email}</a>.",
  user_register_register_error_token_invalid:
    "{siteTitle} does not recognise the registration code you provided. Could you please check and try again. If you \
  continue to experience problems, please accept our apologies and email your details to: \
  <a href='{mailto}:{email}'>{email}</a>.",
  user_register_register_success:
    "Registration successful. You will receive an e-mail containing instructions for verifying your account.",
  user_register_register_error_validation:
    "There was a problem registering your user. Please check you have filled in the form correctly. If you continue \
    to experience problems, please accept our apologies and email your details to: \
    <a href='{mailto}:{email}'>{email}</a>.",
  user_register_salutation: "Salutation",
  user_register_salutation_description: "How {siteTitle} should display your name.",
  user_register_token: "Registration Code",
  user_register_token_description: "The code you have been issued with to allow you to register on the site.",
  user_register_save_fail: "Unable to register the new user.",
  user_register_password_password: "Password",
  user_register_password_confirm_password: "Confirm Password",

  user_verify_error_verifying: "Unable to verify these details.",
  user_verify_code: "Verification code",
  user_verify_code_description: "The 32 character verification code which was e-mailed to you after you registered.",
  user_verify_email: "E-mail",
  user_verify_email_description: "Your registered e-mail address.",
  user_verify_verify: "Verify",
  user_verify_verify_log_in: "Go to the homepage to log in ...",
  user_verify_verify_error_duplicate_email:
    "You are unable to register using this e-mail address because it is already in use.",
  user_verify_verify_error_validation:
    "There was a problem verifying your registration. Please check your details. Note that \
    verification codes expire after 24 hours. In this case, please start the registration process again.",
  user_verify_instructions:
    "To verify your account registration, please enter your email address and the code you were sent. \
    If you did not receive an email containing a code, please check your junk folder.",
  user_verify_verify_success:
    "Your registration has been confirmed. You will receive an e-mail containing your log in details.",
  user_register_error_get_groups: "Unable to get list of joinable groups.",
  user_register_select_groups:
    "If you wish you may join any of the following groups which are of interest to you. \
    You can change this selection from your account page. \
    Note you may also be added to some important groups automatically.",
  user_register_groups_save: "Join Groups",
  user_register_groups_log_me_in: "Never mind. Just log me in ...",
  user_register_groups_log_in: "Log In",
  user_register_groups_success_saving:
    "Your group membership has been saved. You can update your groups from your account page after you log in.",
  user_register_groups_error_saving: "There was a problem setting your group membership.",

  // PDL
  pdl_my_pdl_title: "My {pdlText}",
  pdl_error_get_records: "Unable to get PDL records.",
  pdl_title_date: "Date",
  pdl_title_learning_activity: "Learning activity",
  pdl_title_time: "Time",
  pdl_title_score: "Score",
  pdl_title_links: "Title",
  pdl_title_downloads: "Downloads",
  pdl_revisit_content: "Revisit content: {content_name}",
  pdl_revisit_forum: "Revisit forum: {forum_title}",
  pdl_no_records_found: "No PDL records found.",
  pdl_filter_all_collections: "All Collections",
  pdl_filter_all_records: "All Records",
  pdl_filter_no_collection: "No Collection",
  pdl_label_export: "Export",
  pdl_label_export_csv: "CSV",
  pdl_label_export_pdf: "PDF",
  pdl_label_export_xlsx: "XLSX",
  pdl_label_new_entry: "Add new entry ...",
  pdl_placeholder_new_description: "What did you learn?",
  pdl_label_add_record: "Add record",
  pdl_label_delete_record: "Delete record",
  pdl_label_edit_record: "Edit record",
  pdl_confirm_delete_record: "Are you sure you wish to delete this record?",
  pdl_confirm_delete_record_body: "The record will be permanently deleted. Are you sure you wish to proceed?",
  pdl_delete_record_error_deleting_record: "Unable to delete record",
  pdl_delete_record_success: "Deleted record",
  pdl_save_record_error_saving_record: "Unable to save record",
  pdl_save_record_success: "Saved new record",
  pdl_update_record_success: "Updated record",
  pdl_attach_file_no_attachments: "No attachments.",
  pdl_attach_file_placeholder: "Attach file ...",
  pdl_attach_file_placeholder_inline: "You may attach a file to your {pdlText} if you wish.",
  pdl_attach_file_help_title: "Attach file to your {pdlText} notes",
  pdl_attach_file_error_title: "Unable to attach file to your {pdlText} notes",
  pdl_attach_file_help:
    "<ul>\
    <li>You may attach up to three files to your {pdlText} notes.</li>\
    <li>File names may be up to 64 characters long and should contain only alphanumeric, dash or space characters.</li>\
    <li>Files are limited to 2MB in size.</li>\
    <li>The following file types are accepted: gif, jpg, jpeg, png, doc, docx, odt, pdf, xls, xlsx, txt.</li>\
    </ul>",
  pdl_attach_file_success: "File attached OK",
  pdl_attach_file_error: "Unable to attach file",
  pdl_delete_file_success: "File removed OK",
  pdl_delete_file_error: "Unable to remove file",
  pdl_confirm_remove_file: "Remove File?",
  pdl_confirm_remove_file_body: "Are you sure you wish to remove {filename} from the record?",
  pdl_leader_user_select: "View {pdlText} for user",
  pdl_leader_user_select_help_body:
    "You are a group leader. This means you may view the {pdlText} of other users who are in the groups that you lead.",
  pdl_download_group_leader_reports_title: "Download Group Leader Reports",
  pdl_group_leader: "Group Leader",
  pdl_group_leader_reports_title: "Group Leader Reports",
  pdl_group_leader_members_report_label: "Group members report",
  pdl_group_leader_reports_label_group: "Group",
  pdl_group_leader_reports_label_collection: "Collection",
  pdl_group_leader_reports_label_content: "Content",
  pdl_export_group_members_report_label: "Export Group Members Report",
  pdl_export_completion_report_label: "Export Completion Report",
  pdl_export_content_completion_report_label: "Export Content Completion Report",
  pdl_group_leader_reports_select_content: "Please select a content item ...",
  pdl_membership_number: "Membership number",
  pdl_template_name: "{cpdText} template",
  pdl_template_default: "default template",
  pdl_leader_no_pdl_template_description:
    "This user is not using the default {cpdText} template. No description available.",

  pdl_inline_entry_title: "{pdlText} Notes",
  pdl_inline_entry_help_title: "{pdlText} Entry",
  pdl_inline_entry_help_text:
    "You can edit the following notes, which will be added to your {pdlText} when you click 'Save notes to {pdlText}'.",
  pdl_inline_entry_no_attachments: "No files have been attached to this log.",
  pdl_inline_entry_save_ok: "{pdlText} entry saved ok.",
  pdl_inline_entry_save_fail: "Could not save {pdlText} entry.",
  pdl_inline_placeholder_new_description: "Add notes to your {pdlText} ...",
  pdl_inline_unsaved_title: "Your notes have not been saved.",
  pdl_inline_unsaved_changed_title: "Your notes have unsaved changes.",
  pdl_inline_label_verifiable_learning: "Verifiable {cpdText} learning",
  pdl_inline_label_verifiable_learning_description:
    "Verifiable learning should be accompanied by a file demonstrating compliance with your professional body.",
  pdl_inline_label_cpd_score_hrs: "hrs",
  pdl_inline_label_cpd_score_mins: "mins",
  pdl_time_in_minutes: "Time in minutes",
  pdl_unavailable_content: "Content unavailable",
  pdl_unavailable_forum: "Forum unavailable",

  // Notifications
  notifications_error_get_notifications: "Could not get notifications.",
  notifications_header_date: "Date",
  notifications_header_type: "Type",
  notifications_header_notification: "Notification",
  notifications_visit: "Visit",
  notifications_date_at: " at ",
  notifications_type_all: "All",
  notifications_type_forum_new_post: "New forum post",
  notifications_type_forum_new_comment: "New forum comment",
  notifications_type_forum_reaction: "Forum reaction",
  notifications_type_content_new_content: "New content",
  notifications_type_content_update_content: "Updated content",
  notifications_date_all: "All",
  notifications_date_unseen: "Unseen",
  notifications_date_last_login: "Since last login",
  notifications_no_notifications_found: "No notifications found.",
  notifications_loading: "Loading ...",
  notifications_amend_settings:
    'You can amend the frequency and content of your notifications in \
    <a href="/account" target="_top">settings</a>.',
  notifications_no_notifications_selected:
    'You have opted out of receiving any notifications. To change this, please visit your account \
    <a href="/account" target="_top">settings</a>.',

  // Content preview (group)
  preview_error_fetching_group: "There was a problem fetching the content preview.",
  preview_error_fetching_payment_intent: "There was a problem setting up your payment.",
  preview_error_fetching_countries: "There was a problem fetching country tax data.",
  preview_error_initialising_transaction: "There was a problem setting up this transaction.",
  preview_error_transaction_exists:
    'You have already requested access to this content. Complete your payment in \
    <a href="/account/payments">your account\'s payments tab</a>.',
  preview_unable_to_preview: "Unable to preview this content.",
  preview_already_have_access: "You have access to this content. Click on an item below to view it.",
  preview_already_have_access_payment_notice:
    "You already have access to this content. However, you may still purchase redeemable tokens for other users.",
  preview_contents_label: "This package contains the following content:",
  preview_no_content_found: "No content found.",
  preview_info_price: "Price: £{price} per person",
  preview_label_buy_for_self: "Buy for myself",
  preview_label_buy_tokens: "Buy redeemable tokens for others (max {maximum})",
  preview_label_confirm_purchase: "Confirm purchase",
  preview_label_pay_now: "Pay now",
  preview_label_table_buy_for_self: "Access for me",
  preview_label_table_buy_tokens: "{tokens} access token{plural}",
  preview_payment_form_amount_to_pay: "Amount to pay: <strong>£{price}</strong>",
  preview_error_making_payment: "Unable to complete payment. Please contact an administrator if the problem persists.",
  preview_warning_non_numerical_tokens:
    "You did not select a number of tokens to buy. We have automatically selected the minimum purchase ({minimum}).",
  preview_warning_too_few_tokens:
    "You selected {selected} tokens. The minimum purchase is {minimum}. We have automatically selected this amount.",
  preview_warning_too_many_tokens:
    "You selected {selected} tokens. The maximum purchase is {maximum}. We have automatically selected this amount.",
  preview_select_country: "Please select your country",
  preview_select_country_placeholder: "Please select your country",
  preview_title_payment_form: "Pay For Access ({price} per person)",
  preview_you_are_looking_at_lo: "You are about to register and pay for the following:",
  preview_you_are_looking_at_li: "You are about to pay for the following:",

  // Login or Register email check form
  login_register_error_checking_email: "Unable to check the provided email address.",
  login_register_log_in: "Log in",
  login_register_register: "Register",
  login_register_and_pay: "and pay",
  login_register_lo_footer_or: "OR",
  login_register_lo_enter_email: "Enter your email address to proceed ...",
  login_register_blurb: "Please enter your email address to log in or register.",

  // Payment callback page
  payment_confirm_error_retrieving_payment_intent: "There was a problem retrieving your transaction details.",
  payment_confirm_no_view_payment_details:
    "It is not possible to display your transaction details. Please contact your administrator for assistance.",
  payment_confirm_error_completing_payment_short: "It has not been possible to complete your transaction",
  payment_confirm_error_completing_payment:
    "It has not been possible to complete your transaction. We will keep trying. If the problem persists, please \
    contact your site administrator for help.",
  payment_confirm_payment_succeeded_record_succeeded:
    "Your payment was successful and we have added your purchase to your account.",
  payment_confirm_payment_succeeded_record_pending_1:
    "Your payment was successful. Your purchase will be added to your account shortly.",
  payment_confirm_payment_succeeded_record_pending_2: "Waiting for your transaction to complete ...",
  payment_confirm_payment_error_general:
    "There was a problem completing your transaction. Please contact your site administrator.",
  payment_confirm_content_you_paid_to_access: "You have paid to access the following content:",
  payment_confirm_content_you_paid_to_access_tokens_1:
    "You have paid for {numTokens} token{pluralise} to access the content shown below. Your tokens are:",
  payment_confirm_content_you_paid_to_access_tokens_2:
    "You may issue tokens to users who you wish to have access to the content.",
  payment_confirm_no_tokens_found: "No tokens found.",

  // User account token redemption
  account_redeem_token_title: "Redeem Access Token",
  account_redeem_token_intro_1: "If you have been provided with a token to access content you may redeem it here.",
  account_redeem_token_intro_2: "Once the token is redeemed the content will be added to your {learning} page.",
  account_redeem_token_label_check_token: "Check Token",
  account_redeem_token_help_check_token:
    "Tokens are 17-character, alpha-numeric codes beginning with T, e.g. T123456789ABCDEFG.",
  account_redeem_token_validate_success:
    "Your token is valid and will provide you with access to the content shown below. If you wish to add this content \
    to your account, press &quot;{redeemLabel}&quot;.",
  account_redeem_token_validate_error: "Unable to complete token validation.",
  account_redeem_token_validate_error_malformed: "The token is not correctly formatted.",
  account_redeem_token_validate_error_no_token: "The token was not recognised.",
  account_redeem_token_validate_error_redeemed: "The token has already been redeemed.",
  account_redeem_token_validate_error_group_not_permitted: "The token is for content you are not permitted to access.",
  account_redeem_token_validate_error_group_member: "You already have access to the content the token is for.",
  account_redeem_token_validate_error_no_pay_to_access_company:
    "This site does not permit tokens to be redeemed. This is probably a recent change.",
  account_redeem_token_validate_error_no_pay_to_access_group:
    "The token is for content which does not support paid access. This is probably a recent change to the content.",
  account_redeem_token_validate_error_unknown:
    "An error occurred trying to validate the token. Please contact your site administrator.",
  account_redeem_token_label_redeem: "Redeem Token",
  account_redeem_token_redeem_error: "Unable to complete token redemption.",
  account_redeem_token_redeem_success_notice:
    "Your token has been redeemed. The content shown below has been added to your account. The content may be \
    accessed via the <a href='/user'>&quot;{learning}&quot;</a> page.",
  account_redeem_token_preview_header: "Your token accesses the following content:",

  // User account payment history
  account_payment_history_no_payments_found: "No payments found.",
  account_payment_history_title_type_personal: "Personal",
  account_payment_history_title_type_tokens: "Redeemable tokens",
  account_payment_history_title_redeemed: "Redeemed",
  account_payment_history_title_not_redeemed: "Not redeemed",
  // account_payment_history_title_invoice: "Invoice",
  // account_payment_history_title_pay: "Pay",
  account_payment_history_title_pay_by_card: "Pay By Card",
  account_payment_history_status_all: "All",
  account_payment_history_status_succeeded: "Complete",
  account_payment_history_status_pending: "Outstanding",
  account_payment_history_status_failed: "Failed",
  account_payments_label_pay_now: "Pay now",
  account_payments_title_payment_form: "Pay For Access ({price})",
  account_payments_error_fetching_payment_intent: "There was a problem setting up your payment.",
  account_payments_error_unable_to_download_invoice: "Unable to download Invoice.",
  account_payments_error_fetching_payments: "There was a problem fetching your payment records.",

  // Admin configuration page
  admin_config_title_quick_navigation: "Jump to config item:",
  admin_config_warning_propagation_delay:
    "Note that changes to site configuration may take up to one minute to propagate fully.",
  admin_config_info_self_registration_not_available: "Self registration is not available on this site.",
  admin_config_title_user_self_registration: "User Self Registration",
  admin_config_self_registration_token_title: "Registration Token",
  admin_config_self_registration_token_help: "A code which users must enter when registering on the site.",
  admin_config_self_registration_intro_text_title: "Intro text",
  admin_config_self_registration_intro_text_help:
    "Introductory text to display on the user self registration page. Leave blank to use default text. \
    Enter 'NO_INTRO_TEXT' to remove text entirely.",
  admin_config_title_homepage_navigation_links: "Homepage Navigation Links",
  admin_config_info_navigation_links_not_available: "Navigation links have not been enabled on this site.",
  admin_config_error_fetching_config: "There was a problem fetching the site configuration.",

  // Admin navigation links management tool
  admin_navigation_links_error_fetching_links: "There was a problem fetching the navigation links.",
  admin_navigation_links_error_fetching_targets: "There was a problem fetching available navigation link targets.",
  admin_navigation_links_title_add_page: "Add page",
  admin_navigation_links_title_add_group: "Add group",
  admin_navigation_links_title_add_special: "Add special",
  admin_navigation_links_title_remove_link: "Remove link",
  admin_navigation_links_title_edit: "Edit link",
  admin_navigation_links_select_page_placeholder: "--- Please select a page to add ---",
  admin_navigation_links_label_add_page: "Add page",
  admin_navigation_links_select_group_placeholder: "--- Please select a group to add ---",
  admin_navigation_links_label_add_group: "Add group",
  admin_navigation_links_select_special_placeholder: "--- Please select a special link to add ---",
  admin_navigation_links_label_add_special: "Add special",
  admin_navigation_links_info_notes: "Notes:",
  admin_navigation_links_info_displayed:
    "Any page may be added to the links list. However, which pages are displayed will depend on whether the user is \
    logged in (accordingly with the page's access settings).",
  admin_navigation_links_info_layout: "Links are rendered in a grid layout.",
  admin_navigation_links_no_links: "No links have been added. You can add some from the lists above.",
  admin_navigation_links_save_links: "Save links",
  admin_navigation_links_error_save: "Unable to save links.",
  admin_navigation_links_updated: "Links updated.",
  admin_navigation_links_title_unsaved_changes: "There are unsaved changes to the links.",
  admin_navigation_links_label_link_title: "Link title *",
  admin_navigation_links_label_link_description: "Link description",
  admin_navigation_links_title_required: "Links must have a title",
  admin_navigation_links_add_description: "-- Edit this link to add a description --",
  admin_navigation_links_target_link_target: "<strong>Link target:</strong>",
  admin_navigation_links_target_page: "Page | {title}",
  admin_navigation_links_target_group: "Group | {title}",
  admin_navigation_links_target_special_login_register: "Special | Login or Register (non-editable)",
  admin_navigation_links_target_unknown: "cannot be identified",
  admin_navigation_links_special_label_login_register: "Login or Register",

  // Admin payments page
  admin_payments_error_fetching_payments: "There was a problem fetching your company's payment records.",
  admin_payments_status_all: "All",
  admin_payments_status_succeeded: "Complete",
  admin_payments_status_pending: "Outstanding",
  admin_payments_status_failed: "Failed",
  admin_payments_title_type_personal: "Personal",
  admin_payments_title_type_tokens: "Redeemable tokens",
  admin_payments_title_access_type: "Access Type",
  admin_payments_no_payments_found: "No payments found.",
  admin_payments_title_redeemed: "Redeemed",
  admin_payments_title_not_redeemed: "Not redeemed",
  admin_payments_complete_transaction: "Complete",
  admin_payments_modal_title_confirm_complete_transaction: "Manually Complete Transaction?",
  admin_payments_modal_body_confirm_complete_transaction:
    "Are you sure you wish to mark this transaction as complete? \
    The user ({email}) will gain access to the content ({content}).",
  admin_payments_error_completing_transaction: "There was a problem completing the transaction.",
  admin_payments_success_completing_transaction_user:
    "The transaction has been marked complete. The user has been notified that they have access to the content.",
  admin_payments_success_completing_transaction_token:
    "The transaction has been marked complete. The user has been notified that access tokens have been generated.",

  // Admin page management
  admin_page_error_fetching_page: "There was a problem fetching the page.",
  admin_page_error_fetching_page_images: "There was a problem fetching images for inclusion in the page.",
  admin_page_created_ok: "New page created.",
  admin_page_error_creating_page: "Unable to create new page.",
  admin_page_error_creating_page_duplicate_alias: "Unable to create new page. A page with this alias already exists.",
  admin_page_updated_ok: "Page updated.",
  admin_page_error_updating_page: "Unable to update the page.",
  admin_page_error_updating_page_duplicate_alias: "Unable to update the page. A page with this alias already exists.",
  admin_page_label_title: "Title *",
  admin_page_label_alias: "Alias *",
  admin_page_description_alias:
    "The alias is used as the final part of the page URL. For example, if alias is 'about-us' then you will be able \
    to navigate to it at https://yourdomain/about-us. It should be unique and contain only lowercase letters, numbers, \
    underscores and dashes (e.g. 'page-alias_1').",
  admin_page_label_published: "Published",
  admin_page_description_published:
    "Only published pages may be viewed or appear in the menu. Unpublishing a page removes it from all navigation \
    links lists.",
  admin_page_label_display_when: "Display",
  admin_page_description_display_when: "Determines whether the user should be logged in to access this page.",
  admin_page_label_display_in_navigation: "Display in navigation",
  admin_page_description_display_in_navigation: "Determines wether a link to the page is shown in the site navigation.",
  admin_page_option_display_both: "Always",
  admin_page_option_display_loggedin: "Only when user is logged in",
  admin_page_option_display_loggedout: "Only when user is logged out",
  admin_page_label_open_new_tab: "Open in new tab",
  admin_page_description_open_new_tab:
    "Causes links to this page to open in a new tab. Includes the site navigation and navigation links on the \
    homepage and other pages.",
  admin_page_label_content: "Content 1",
  admin_page_description_content: "Main page content. Displayed before navigation links (if any).",
  admin_page_label_content_bottom: "Content 2",
  admin_page_description_content_bottom:
    "Second area of content displayed after navigation links. Only really useful if navigation links are in use.",
  admin_page_label_external_url: "External URL",
  admin_page_description_external_url:
    "If set, header navigation will link to the specified URL, and the URL will be shown in-page.",
  admin_page_label_navigation_class: "Navigation class",
  admin_page_description_navigation_class:
    "If set, this class is applied to the header navigation item. It should contain only lowercase letters, \
    underscores and dashes (e.g. 'page_navigation-class').",
  admin_page_label_order: "Navigation order *",
  admin_page_description_order:
    "The ordering of this page in the site navigation, relative to other pages. Should be zero or a positive integer.",
  admin_page_tab_details: "Details",
  admin_page_tab_navigation_link: "Navigation links",
  admin_page_create_page_to_set_navigation_links: "You must create the page before adding in-page navigation links.",
  admin_page_navigation_links_info:
    "A set of navigation links to other parts of the site may be added to this page. The links are displayed in a \
    grid below the page's content.",
  admin_page_edit_thumbnail_label: "Page thumbnail",
  admin_page_edit_thumbnail_help: "A thumbnail image displayed when the page is included in a set of navigation links.",
  admin_page_edit_thumbnail_upload: "Page thumbnail",
  admin_page_create_page_to_add_thumbnail: "You will be able to add a page thumbnail once the page is created.",

  // Admin image management
  admin_images_error_fetching_images: "There was a problem fetching images for inclusion in the page.",
  admin_images_available_images: "Available Images",
  admin_images_no_available_images: "No images found.",
  admin_images_add_image: "Add Image",
  admin_images_new_image: "New Image",
  // admin_images_management_intro:
  //   "Images uploaded here will be available for inclusion in the HTML content editors on page administration screens. \
  //   Images are automatically resized to a have a width of 500px and saved in jpg format.",
  admin_images_management_intro:
    "<p>By default, the image will be displayed on the page with a width of 500 pixels. Its height will automatically \
    be scaled if the aspect ratio is changed from the default. The size of the image displayed on a page can be \
    changed in Admin/Pages/Edit Page using the <> icon.</p> \
    <p>The uploaded file will have the same name as the original file, except non alpha-numeric characters will be \
    replaced with underscores.</p> \
    <p>If a file is uploaded with a name matching that of a previously uploaded file, the \
    previous file will be replaced. This will affect any pages where the existing image was used (i.e. those pages \
    will automatically display the new image).</p>",
  admin_images_management_available_images_intro:
    "You can delete images entirely from the image manager or use the edit icon to replace the existing image with a \
    new image, retaining the same file name. Replacing or deleting images will affect any pages where an existing \
    image has been used.",
};

export default en_gb;
